<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import Vue from 'vue'

export default {
  mounted(){
    Vue.cordova.on('deviceready', () => {
      this.$store.commit('cordova', true)
      document.addEventListener("backbutton", (e) => {
        // e.preventDefault()
        window.history.back()
      })
      Keyboard.shrinkView(true)
      window.open = cordova.InAppBrowser.open
    })
  }

}
</script>

<style lang="sass">

</style>





// WEBPACK FOOTER //
// App.vue?05e63a3c